<template src="./index.html"></template>
<script>
	import addzc from '../addzc/index.vue';
	import seezc from '../seezc/index.vue';
	import config from '../../../../configHttp.js';
	import uploadFile from '../uploadFile/index.vue';
	import uploadFileplus from '../uploadFileplus/index.vue';
	import axios from 'vue';
	import data from './data.js';
	import {
		querycell,
		writesave,
		startShenBao,
		forShengcdg,
		manuscriptqueryReportStep,
		manuscriptwriteimport,
		manuscriptUploadFile,
		annexadd,
		UploadNotes,
		queryNotes,
		query_Appended,
		cwbb_appended_save,
		cwbb_appended_update,
    getStandardFormulaCalculationLog
	} from '../../../api/Draftgeneration.js';
	import {
		querytemplatecell,
		getShuibDetailList,
		templatecellsave
	} from '../../../api/bbmb.js';
	import {
		reportquerytrack
	} from '../../../api/xggj.js';
	import {
		zcfg_fycx,
		zcfg_fetch
	} from '../../../api/zcfg.js';
  import {
    detailsingleQuery,
    landinit,
    tudztxxdelete,
    tudztxxsave,
    tudztxxupdate,
    generatePapersCztdAdd,
    fangwxxupdate, fangwxxsave, fangwxxdelete, fangwxxpage, generatePapersFcsDetailAdd
  } from '../../../api/cztds.js'
  import {getdata} from "../../page/DataGovernance/cztdsys/mxdj/cjjzfcs/cjjzfcsInvoice/data";
	export default {
		name: '',
		components: {
			addzc,
			seezc,
			uploadFile,
			uploadFileplus
		},
		data: function() {
			return {
				//文件上传
				filediag: false,
				//文件附注
				fileUpload: false,
				notes: null,
				upformdata: {},
				formdata: {
					type: '',
					name: '',
					description: ''
				},
				upfile: {},
				updiag: false,
				formlist: data.formlist,
				choosetable: [],
				chooseindex: '',
				choosecolum: {},
				smdiag: false,
				//单元格批注
				pzdiag: false,
				zcdiag: false,
				//政策
				addzcdiag: false,
				searchdatazc: {
					policyTitle: '',
					policyType: '',
					isValid: ''
				},
				searchlistzc: data.searchlistzc,
				headDatazc: data.headDatazc,
				tableDatazc: [],
				pagination: data.pagination,
				seezcformlist: data.seezcformlist,
				formdatazc: data.formdatazc, //form表单数据
				fbkyuwduixi: {
					originalLink: '',
					content: ''
				}, //源文件链接文本框数据
				zclist: [], //政策
				upformdataadd: [], //文件
				seezcdiag: false,
				Asmtext: this.smtext,
				Appended: {
					"bianzjc": "",
					"companyNo": "",
					"createBy": null,
					"createTime": null,
					"delFlag": "0",
					"gengzsm": "",
					"id": null,
					"kuaijgj": "",
					"qiyjbqk": "",
					"shenbq": "",
					"shuibId": null,
					"shuomsx": "",
					"updateBy": null,
					"updateTime": null,
					"xiangmsm": "",
					"zhengccxxx": "",
					"zunxsm": ""
				},
        // 城镇土地使用税
        cztdsCopyinvoice: false,
        cztdsCopyinvoices: false,
        cztdsHeadData: data.cztdsHeadData,
        cztdsPagination: data.cztdsPagination,
        cztdsTableData: [{}],
        mxsearch:{},
        maplist:[
          {
            value:null,
            item:'未采集'
          },
          {
            value:1,
            item:'未采集'
          },
          {
            value:2,
            item:'采集成功'
          },
          {
            value:3,
            item:'采集失败'
          },
          {
            value:4,
            item:'采集中'
          }
        ],
        cztdsValue2: '',
        cztdsSelect_error: false,
        cztdsFormlist: data.cztdsFormlist,
        cztdsFormdata: data.cztdsFormdata,
        options: [],
        cztdsIndex: [],
        // 从价计征房产税
        cjfcCopyinvoice: false,
        cjfcCopyinvoices: false,
        cjfcHeadData: data.cjfcHeadData,
        cjfcPagination: data.cjfcPagination,
        cjfcTableData: [{}],
        fcFormList1: data.fcFormList1,
        fcFormList2: data.fcFormList2,
        fcFormList3: data.fcFormList3,
        fcFormList4: data.fcFormList4,
        fcFormList5: data.fcFormList5,
        cjfcFormdata: data.cjfcFormdata,
        cjfcValue2: '',
        cjfcSelect_error: false,
        cjfcIndex: [],
        fcArr2: ["czchuzfcmj","chengzMc","chengzNsrsbh","shenbzjsr","zulqq","zulqz"],
        logDiag: false,
        logInfo: "",
			};
		},
		props: {
			type: {
				type: String,
				default: ''
			},
			params: {
				type: Object,
				default: {}
			},
			suosq: {
				type: String,
				default: ''
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			choosetitleindex: {
				type: String,
				default: ''
			},
			choosecellCode: {
				type: String,
				default: ''
			},
			smtext: {
				type: String,
				default: ''
			},
			zcdata: {
				type: Array,
				default: []
			},
      jiaJDkBl: {
        type: String,
        default: ''
      },
      baohckyw: {
        type: String,
        default: ''
      }
		},
		created() {},
		mounted() {
			this.onkeydown();
      if (this.params.sbbm==='cztds' || this.params.sbbm === "fcs") {
        landinit().then((res) => {
          if (res.data.code == 1) {
            this.mxsearch = res.data.data
            Object.keys(this.mxsearch).map(key => {
              let arr = Object.keys(this.mxsearch[key]).map(keyout => {
                return {
                  value: this.mxsearch[key][keyout],
                  label: keyout
                }
              })
              this.mxsearch[key] = arr
            })
          }
        });
        this.uetiu();
      }
		},
		activated() {
			this.onkeydown();
		},
		deactivated() {
			document.onkeydown = '';
		},
		methods: {
			Upload_notes() {
				// this.$emit("Upload_notes",'')
				let params = {
					"companyNo": this.params.companyNo,
					"shenbq": this.suosq,
					"shuibId": this.params.shuibId,
				}
				query_Appended(params).then((res) => {
					if (res.data.code == 1) {
						if (res.data.data != null) {
							this.Appended = res.data.data
						}
						this.fileUpload = true;
					} else {
						this.$message.error(res.data.msg);
					}
				})
				// this.$nextTick(() => {
				// 	this.$refs['uploadfileRef'].forrefresh();
				// });
				this.query_Notes();
			},
			getupload_notes_params(e) {
				this.upformdata = e;
			},
			notes_file() {
				let params = {
					downUrl: config.baseURL + '/manuscript/downloadCwbbFile',
					typeObj: {
						toForm: true,
						fileType: 'xlsx',
						failUrl: this.$winURl
					},
					params: {
						id: this.params.id
					}
				};
				this.$downloadcommon(params);
			},
			query_Notes() {
				queryNotes({
					id: this.params.id
				}).then((res) => {
					if (res.data.code == 1) {
						this.notes = res.data.data.fileName;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			//确认上传
			forsubmit_notes_file() {
				this.Appended.companyNo = this.params.companyNo
				this.Appended.shenbq = this.suosq
				this.Appended.shuibId = this.params.shuibId
				if (this.Appended && (this.Appended.id != "" && this.Appended.id != null && this.Appended.id !=
						undefined)) {
					cwbb_appended_update(this.Appended).then(res => {
						if (res.data.code == 1) {
							this.$message.success("操作成功！");
							this.fileUpload = false;
						} else {
							this.$message.error(res.data.msg);
						}
					})
				} else {
					cwbb_appended_save(this.Appended).then(res => {
						if (res.data.code == 1) {
							this.$message.success("操作成功！");
							this.fileUpload = false;
						} else {
							this.$message.error(res.data.msg);
						}
					})
				}
				// UploadNotes({
				// 	file: this.upformdata.upfile,
				// 	id: this.params.id
				// }).then((res) => {
				// 	if (res.data.code == 1) {
				// 		this.fileUpload = false;
				// 	} else {
				// 		this.$message.error(res.data.msg);
				// 	}
				// });
			},
			get_notes_filelist() {},
			forsave() {
				this.$emit('forsave', '');
			},
			commanddcrefresh(e) {
				this.$emit('commanddcrefresh', e);
			},
			zcsclick(id) {
				let params = {};
				params.id = id;
				zcfg_fetch(params).then((res) => {
					if (res.data.data != null) {
						this.formdata = res.data.data;
						this.formdata.id = id;
						this.zclist = res.data.data.policyList;
						this.upformdataadd = res.data.data.policyFileList.map((item) => {
							return {
								upfilename: item.filePrefix + item.fileSuffix,
								suoming: item.fileDesc,
								policyFileList: item.id,
								fileUrl: item.fileUrl
							};
						});
						this.seezcdiag = true;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			closeseezcdiag() {
				this.seezcdiag = false;
			},
			// 查询进行发票合计结果(分页)
			fetchResultShow() {
				let params = JSON.parse(JSON.stringify(this.searchdatazc));
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.sort = '';
				params.order = '';
				zcfg_fycx(params).then((res) => {
					this.pagination.total = res.data.data.total;
					this.tableDatazc = res.data.data.records;
					this.addzcdiag = true;
				});
			},
			sizechange(e) {
				this.pagination.pageSize = e;
				this.fetchResultShow();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.fetchResultShow();
			},
			submitSearch() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},
			foraddzc() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},
			addzc() {
				const chooseval = this.$refs.tablebox.getSelectionval();
				chooseval.forEach((item) => {
					if (!(this.zcdata && this.zcdata.map((gtem) => gtem.id).includes(item.id))) {
						this.zcdata.push(item);
					}
				});
				this.addzcdiag = false;
			},
			onkeydown() {
				document.onkeydown = () => {
					if (window.event && (window.event.keyCode == 112 || window.event.keyCode == 16)) {
						if (this.type == 'tosee' && !this.toseeUpdate) {
							return false;
						}
						if (this.$emptyandnull(this.choosetable)) {
							if (window.event.keyCode == 16) {
								return false;
							}
							if (this.toseeUpdate) {
								this.$message.error('请选择要添加说明的格子');
							} else {
								this.$message.error('请选择要更正说明的格子');
							}
							return false;
						}
						if (this.toseeUpdate) {
							this.pzdiag = true;
						} else {
							this.smdiag = true;
						}
						return false;
					}
					if (window.event && window.event.keyCode == 9) {
						this.refreshhover();
					}
				};
			},
			forxzsm() {
				templatecellsave({
					cellCode: this.choosecellCode,
					cellDesc: this.Asmtext,
					id: this.params.id,
					zcId: this.zcdata.map((item) => item.id)
				}).then((res) => {
					if (res.data.code == 1) {
						this.pzdiag = false;
						this.$emit('forxzsm', this.choosetable, this.choosecolum, this.chooseindex, this.Asmtext,
							this.zcdata);
					}
				});
			},
			forgengzheng() {
				this.smdiag = false;
				this.$emit('forgengzheng', this.choosetable, this.choosecolum, this.chooseindex, this.Asmtext);
			},
			fordelete(index) {
				this.zcdata.splice(index, 1);
			},
			zcsearch() {
				this.zcdiag = true;
			},
			//选中格子
			forhover(table, colum, index) {
				this.refreshhover();
				this.choosetable = table;
				this.chooseindex = index;
				this.choosecolum = colum;
				this.$emit('getchoosecellCode', table, colum, index);
			},
			//重置所有说明
			refreshhover() {
				if (this.smdiag || this.pzdiag) {
					return false;
				}
				this.choosetable = '';
				this.chooseindex = '';
				this.choosecolum = {};
				this.$emit('getchoosecellCode', '');
			},
			//按钮逻辑
			forsb() {
				let params = {
					aggOrgId: '406309843523776',
					companyNo: '123456789A001',
					period: '7',
					id: '1548949165625737218',
					szType: 'ybData',
					year: '2022'
				};
				startShenBao(params).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
      // 一键生成底稿
			forShengcdg() {
        let params = {
          companys: [{
            companyNo: this.params.companyNo,
            id: this.params.id,
            sbbm: this.params.sbbm,
            shuibId: this.params.shuibId,
            templateId: this.params.templateId
          }],
          suosq: this.suosq
        };
        forShengcdg(params).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.$emit('querycell', 'forShengcdg');
          } else {
            this.$message.error(res.data.msg);
          }
        });
			},
			forseegj() {
				this.$router.push({
					path: '/gjck',
					query: {
						Saleparam: JSON.stringify(this.params),
						suosq: this.suosq
					}
				});
			},
			commanddc(e) {
				if (e == 'excel') {
					let params = {
						downUrl: config.baseURL + 'manuscript/write/export',
						typeObj: {
							toForm: false,
							//fileName:"申报报表",
							fileType: 'xlsx',
							failUrl: this.$winURl
						},
						params: {
							companyNo: this.params.companyNo,
							id: this.params.id,
							sbbm: this.params.sbbm,
							shuibId: this.params.shuibId
						}
					};
					this.$downloadcommon(params);
				} else if (e == 'pdf') {
					let params = {
						downUrl: config.baseURL + 'manuscript/write/exportPdf',
						typeObj: {
							toForm: false,
							//fileName: "申报报表",
							fileType: 'pdf',
							failUrl: this.$winURl
						},
						params: {
							companyNo: this.params.companyNo,
							id: this.params.id,
							sbbm: this.params.sbbm,
							shuibId: this.params.shuibId
						}
					};
					this.$downloadcommon(params);
				}
			},
			//上传附件
			getuploadparamsplus(e) {
				
				this.upfile.file=e.upfile
				this.upfile.fileName = e.upfilename;
				
				// manuscriptUploadFile({
				// 	file: e.upfile
				// }).then((res) => {
				// 	if (res.data.code == 1) {
				// 		this.upfile.fileName = res.data.data.fileName;
				// 		this.upfile.fileUrl = res.data.data.fileUrl;
				// 	} else {
				// 		this.$message.error(res.data.msg);
				// 	}
				// });
			},
			closeupdiag() {
				this.updiag = false;
			},
			forsubmit() {
				if (this.$emptyandnull(this.upfile.fileName)) {
					this.$message.error('请选择要上传的文件');
					return false;
				}
				let params = JSON.parse(JSON.stringify(this.formdata));
				// params.fileName = this.upfile.fileName;
				// params.fileUrl = this.upfile.fileUrl;
				params.file = this.upfile.file;
				params.id = this.upfile.id;
				annexadd(params).then(res => {
					if (res.data.code == 1) {
						this.updiag = false;
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
				
				
				// if (this.$emptyandnull(this.upfile.fileUrl)) {
				// 	this.$message.error('请选择要上传的文件');
				// 	return false;
				// }
				// let params = JSON.parse(JSON.stringify(this.formdata));
				// params.fileName = this.upfile.fileName;
				// params.fileUrl = this.upfile.fileUrl;
				// params.id = this.upfile.id;
				// annexadd(params).then((res) => {
				// 	if (res.data.code == 1) {
				// 		this.updiag = false;
				// 		this.$message.success(res.data.msg);
				// 	} else {
				// 		this.$message.error(res.data.msg);
				// 	}
				// });
			},
			forupdiag() {
				Object.keys(this.formdata).map((key) => (this.formdata[key] = ''));
				Object.keys(this.upfile).map((key) => (this.upfile[key] = ''));
				this.upfile.id = this.params.id;
				this.updiag = true;
			},
			//文件导入
			forupload() {
				this.upformdata = {};
				this.filediag = true;
				this.$nextTick(() => {
					this.$refs['uploadfileRef'].forrefresh();
				});
			},

			//下载模板
			fordownloadmb() {
				let params = {
					downUrl: config.baseURL + 'manuscript/write/uploads',
					typeObj: {
						toForm: true,
						fileName: '报表模板',
						fileType: 'xlsx',
						failUrl: this.$winURl
					},
					params: {
						sbbm: this.params.sbbm
					}
				};
				this.$downloadcommon(params);
			},
			//获取下载参数
			getuploadparams(e) {
				this.upformdata = e;
			},
			//确认上传
			forsubmitfile() {
				manuscriptwriteimport({
					file: this.upformdata.upfile,
					shenbaoid: this.params.id
				}).then((res) => {
					if (res.data.code == 1) {
						this.filediag = false;
						this.$emit('querycell', '');
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
      exportBusinessSituation() {
        this.$emit('exportBusinessSituation');
      },
	  exportIncomeDifference() {
        this.$emit('exportIncomeDifference');
      },
      // 新增土地信息开始
      newLandInformation() {
        this.cztdsCopyinvoice = true;
        this.cztdsPage();
      },
      cztdsXzzt() {
        this.cztdsValue2 = 2;
        this.cztdsSelect_error = false;
        this.cztdsFormlist[14].selectval = [];
        this.cztdsFormdata = data.cztdsFormdata
        Object.keys(this.cztdsFormdata).map(key => {
          if(key == 'nsywYxqz'){
            this.cztdsFormdata[key] = '2099-12-31';
          }else{
            this.cztdsFormdata[key] = '';
          }
        });
        this.cztdsFormdata = JSON.parse(JSON.stringify(this.cztdsFormdata))
        this.cztdsInfo();
        this.cztdsCopyinvoices = true;
        this.$refs.cztdsTaxform.clearValidate();
      },
      cztdsSizechange(e) {
        this.cztdsPagination.pageSize = e;
        this.cztdsPage();
      },
      cztdsCurrentChange(e) {
        this.cztdsPagination.pageNum = e;
        this.cztdsPage();
      },
      cztdsXq(e) {
        this.cztdsFormdata = JSON.parse(JSON.stringify(e));
        this.cztdsFormdata.tudzldzShi = [e.tudzldzSheng, e.tudzldzShi, e.tudzldzXian];
        this.cztdsInfo();
        this.cztdsCopyinvoices = true;
        this.cztdsValue2 = 1;
      },
      // 初始化数据
      cztdsInfo() {
        this.cztdsFormlist.map(item => {
          if (item.prop == 'nsrlx') {
            item.selectval = [];
            this.mxsearch.cztdNsrxz.map(item1 => {
              item.selectval.push(item1);
            });
          } else if (item.prop == 'tudxz') {
            item.selectval = [];
            this.mxsearch.cztdTdxz.map(item1 => {
              item.selectval.push(item1);
            });
          } else if (item.prop == 'tudyt') {
            item.selectval = [];
            this.mxsearch.cztdTdyt.map(item1 => {
              item.selectval.push(item1);
            });
          } else if (item.prop == 'tudqdfs') {
            item.selectval = [];
            this.mxsearch.cztdTdqdfs.map(item1 => {
              item.selectval.push(item1);
            });
          } else if (item.prop == 'tuddj') {
            item.selectval = [];
            this.mxsearch.cztdTddj.map(item1 => {
              item.selectval.push(item1);
            });
          }
        });
      },
      cztdsPage() {
        let params = {
          nsrsbh: this.params.nsrsbh,
          size: this.cztdsPagination.pageSize,
          current: this.cztdsPagination.pageNum
        };
        detailsingleQuery(params).then(res => {
          if (res.data.code == 1) {
            res.data.data.records.map(item => {
              if (item.nsrlx) {
                this.mxsearch.cztdNsrxz.map(item1 => {
                  if (item.nsrlx == item1.value) {
                    item.nsrlxx = item1.label;
                  }
                });
                this.mxsearch.cztdTdbglxXxxbg.map(item2 => {
                  if (item.nsrlx == item2.value) {
                    item.nsrlxx = item2.label;
                  }
                });
              }
              if (item.tudxz) {
                this.mxsearch.cztdTdxz.map(item1 => {
                  if (item.tudxz == item1.value) {
                    item.tudxzx = item1.label;
                  }
                });
              }
              if (item.tudyt) {
                this.mxsearch.cztdTdyt.map(item1 => {
                  if (item.tudyt == item1.value) {
                    item.tudytx = item1.label;
                  }
                });
              }
              if (item.tudqdfs) {
                this.mxsearch.cztdTdqdfs.map(item1 => {
                  if (item.tudqdfs == item1.value) {
                    item.tudqdfsx = item1.label;
                  }
                });
              }
            });
            this.cztdsTableData = res.data.data.records;
            this.cztdsPagination.total = res.data.data.total;
            setTimeout(v => {
              this.cztdsCopyinvoice = true;
            }, 0);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      cztdsGetdatasave() {
        let outx = { ...this.cztdsFormdata };
        outx.nsrsbh = this.params.nsrsbh;
        outx.tudzldzSheng = outx.tudzldzShi[0];
        outx.tudzldzXian = outx.tudzldzShi[2];
        outx.tudzldzShi = outx.tudzldzShi[1];
        let params = outx;
        if (this.cztdsValue2 == 2) {
          tudztxxsave(params).then(res => {
            if (res.data.code == 1) {
              this.cztdsCopyinvoices = false;
              this.cztdsPage();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          tudztxxupdate(params).then(res => {
            if (res.data.code == 1) {
              this.cztdsCopyinvoices = false;
              this.cztdsPage();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      },
      cztdsAlone() {
        if (this.cztdsFormdata.tudzldzShi == '') {
          this.cztdsSelect_error = true;
        }
      },
      cztdsOutset(e) {
        this.cztdsFormdata.tudzldzXiangz = '';
        this.cztdsSelect_error = false;
        let index = 0;
        let UrbanData = window.$UrbanData_mb || window.$UrbanData;
        this.cztdsUrban(UrbanData, e, index);
        this.cztdsFormlist[16].selectval = this.cztdsIndex;
      },
      cztdsUrban(list, e, index) {
        list.map(item => {
          if (item.value == e[index]) {
            if (index < 2) {
              index++;
              this.cztdsUrban(item.children, e, index);
            } else {
              this.cztdsIndex = item.children;
            }
          }
        });
      },
      uetiu() {
        let UrbanData = window.$UrbanData_mb || window.$UrbanData;
        keyt(UrbanData);
        function keyt(data) {
          data.map(item => {
            item.value = item.label;
            if (item.children) {
              keyt(item.children);
            }
          });
        }
        let data = JSON.parse(JSON.stringify(UrbanData));
        this.options = data.map(item => {
          item.children.map(item1 => {
            item1.children.map(item2 => {
              delete item2.children;
            });
          });
          return item;
        });
      },
      cztdsRemove() {
        if (this.cztdsValue2 == 1) {
          this.$showConfirm({
            message: '确认删除?'
          }).then(res => {
            if (res == 'confirm') {
              let params = { id: this.cztdsFormdata.id };
              tudztxxdelete(params).then(res => {
                if (res.data.code == 1) {
                  this.cztdsCopyinvoices = false;
                  this.cztdsPage();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
            }
          });
        } else {
          this.cztdsCopyinvoices = false;
        }
      },
      cztdsNextztxx() {
        if (this.cztdsFormdata.tudzldzShi == '') {
          this.cztdsSelect_error = true;
          this.$refs.cztdsTaxform.submitForm();
        } else {
          this.$refs.cztdsTaxform.submitForm();
        }
      },
      // 新增土地信息结束
      // 新增房产信息开始
      newAdValoremRealEstateInformation() {
        this.cjfcCopyinvoice = true;
        this.cjfcPage();
      },
      cjfcPage() {
        let params = {
          nsrsbh: this.params.nsrsbh,
          size: this.cjfcPagination.pageSize,
          current: this.cjfcPagination.pageNum
        };
        fangwxxpage(params).then(res => {
          if (res.data.code == 1) {
            res.data.data.records.map(item => {
              if (item.nsrlx) {
                this.mxsearch.cjjzNsrxz.map(item1 => {
                  if (item.nsrlx == item1.value) {
                    item.nsrlxx = item1.label;
                  }
                });
              }
              if (item.fangcyt) {
                this.mxsearch.cjjzFcyt.map(item1 => {
                  if (item.fangcyt == item1.value) {
                    item.fangcytx = item1.label;
                  }
                });
              }
              if (item.bianglx) {
                this.mxsearch.cjjzTdbglxNsywzz.map(item1 => {
                  if (item.bianglx == item1.value) {
                    item.bianglxx = item1.label;
                  }
                });
                this.mxsearch.cjjzTdbglxXxxbg.map(item1 => {
                  if (item.bianglx == item1.value) {
                    item.bianglxx = item1.label;
                  }
                });
              }
            });
            this.cjfcTableData = res.data.data.records;
            this.cjfcPagination.total = res.data.data.total;
            setTimeout(v=>{
              this.cjfcCopyinvoice = true;
            },0)
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      cjfcXzzt() {
        this.fcFormList1=data.fcFormList1
        this.fcFormList2=data.fcFormList2
        this.fcFormList3=data.fcFormList3
        this.fcFormList4=data.fcFormList4
        this.fcFormList5=data.fcFormList5
        const index = this.fcFormList5.findIndex(item => item.prop === 'bgsj');
        if (index !== -1) {
          this.fcFormList5.splice(index, 1);
        }
        this.cjfcFormdata.fangwzldzXiangz = '';
        this.cjfcSelect_error = false;
        this.cjfcInfo();
        this.cjfcFormdata = data.cjfcFormdata
        Object.keys(this.cjfcFormdata).map(key => {
          if (key == 'dailrysfzlx') {
            this.cjfcFormdata[key] = '201';
          } else if (key == 'nsywYxqz') {
            this.cjfcFormdata[key] = '2099-12-31';
          } else {
            this.cjfcFormdata[key] = '';
          }
        });
        this.cjfcFormdata = JSON.parse(JSON.stringify(this.cjfcFormdata))
        this.cjfcCopyinvoices = true;
        this.cjfcValue2 = 1;
        this.chuzfcmjChange("")
        this.$refs.cjfcTaxform.clearValidate();
      },
      cjfcInfo() {
        this.fcFormList1.map(item => {
          if (item.prop == 'nsrlx') {
            item.selectval = [];
            this.mxsearch.cjjzNsrxz.map(item1 => {
              item.selectval.push(item1);
            });
          } else if (item.prop == 'fangcyt') {
            item.selectval = [];
            this.mxsearch.cjjzFcyt.map(item1 => {
              item.selectval.push(item1);
            });
          } else if (item.prop == 'cqzhlx') {
            item.selectval = [];
            this.mxsearch.fcsCqzhlb.map(item1 => {
              item.selectval.push(item1);
            });
          }
        });
      },
      cjfcSizechange(e) {
        this.cjfcPagination.pageSize = e;
        this.cjfcPage();
      },
      cjfcCurrentChange(e) {
        this.cjfcPagination.pageNum = e;
        this.cjfcPage();
      },
      cjfcXq(e) {
        this.fcFormList1=data.fcFormList1
        this.fcFormList2=data.fcFormList2
        this.fcFormList3=data.fcFormList3
        this.fcFormList4=data.fcFormList4
        this.fcFormList5=data.fcFormList5
        this.cjfcFormdata = JSON.parse(JSON.stringify(e));
        this.cjfcFormdata.fangwzldzShi = [e.fangwzldzSheng, e.fangwzldzShi, e.fangwzldzXian];
        this.cjfcCopyinvoices = true;
        this.cjfcInfo();
        this.cjfcValue2 = 2;
        this.chuzfcmjChange(this.cjfcFormdata.chuzfcmj)
      },
      cjfcGetdata() {
        let outx = JSON.parse(JSON.stringify(this.cjfcFormdata));
        outx.nsrsbh = this.params.nsrsbh;
        outx.fangwzldzSheng = outx.fangwzldzShi[0];
        outx.fangwzldzXian = outx.fangwzldzShi[2];
        outx.fangwzldzShi = outx.fangwzldzShi[1];
        let params = outx;
        if (this.cjfcValue2 == 2) {
          fangwxxupdate(params).then(res => {
            if (res.data.code == 1) {
              this.cjfcCopyinvoices = false;
              this.cjfcPage();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          fangwxxsave(params).then(res => {
            if (res.data.code == 1) {
              this.cjfcCopyinvoices = false;
              this.cjfcPage();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      },
      cjfcAlone() {
        if (this.cjfcFormdata.fangwzldzShi == '') {
          this.cjfcSelect_error = true;
        }
      },
      cjfcHandleChange(e) {
        this.cjfcFormdata.fangwzldzXiangz = '';
        this.cjfcSelect_error = false;
        let index = 0;
        let UrbanData = window.$UrbanData_mb || window.$UrbanData;
        this.cjfcUrban(UrbanData, e, index);
        this.fcFormList2[1].selectval = this.cjfcIndex;
      },
      cjfcUrban(list, e, index) {
        list.map(item => {
          if (item.value == e[index]) {
            if (index < 2) {
              index++;
              this.cjfcUrban(item.children, e, index);
            } else {
              this.cjfcIndex = item.children;
            }
          }
        });
      },
      cjfcRemove() {
        if (this.cjfcValue2 == 2) {
          this.$showConfirm({
            message: '确认删除?'
          }).then(res => {
            if (res == 'confirm') {
              let params = {
                id: this.cjfcFormdata.id
              };
              fangwxxdelete(params).then(res => {
                if (res.data.code == 1) {
                  this.cjfcCopyinvoices = false;
                  this.cjfcPage();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
            }
          });
        } else {
          this.cjfcCopyinvoices = false;
        }
      },
      cjfcNextxx() {
        if (this.cjfcFormdata.fangwzldzShi == '') {
          this.cjfcSelect_error = true;
          this.$refs.cjfcTaxform.submitForm();
        } else {
          this.$refs.cjfcTaxform.submitForm();
        }
      },
      chuzfcmjChange(val) {
        console.log("chuzfcmjChange")
        for (let i = 0; i < 6; i++) {
          if (val > 0) {
            console.log(val)
            console.log(this.fcFormList4[i])
            this.fcFormList4[i].disabled = false;
          } else {
            this.fcFormList4[i].disabled = true;
            this.cjfcFormdata[this.fcArr2[i]] = "";
          }
        }
      },
      // 新增房产信息结束
      // 标准公式计算日志
      standardFormulaCalculationLog() {
        getStandardFormulaCalculationLog({id: this.params.id}).then((res) => {
          if (res.data.code === "1") {
            this.logDiag = true;
            this.logInfo = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    }
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>